import BaseRoute from "../../../../../../lib/itn-ui-kit/route/base-route";
import { service } from "../../../../../../lib/itn-ui-kit/services/service-container";

import Template from "./template";

export default class MedicalInjuries extends BaseRoute {
  @service("repositories/case-injuries-repository") caseInjuriesRepository;
  @service("repositories/case-injuries-graph-repository")
  caseInjuriesGraphRepository;

  element = (<Template />);
  revalidateOnQueryAnyChange = false;
  revalidateOnParams = ["id"];
  revalidateOnQueryKeys = ["rvClientDetail"];
  allowManualRevalidate = false;

  async loader({ params }) {
    const { id } = params;

    // Data to return
    let injuries = [];
    let caseInjuriesGraph = {};

    if (id) {
      try {
        injuries = await this.caseInjuriesRepository.query({ case: id });
        caseInjuriesGraph = await this.caseInjuriesGraphRepository.query(id);
      } catch (error) {
        console.error("Error fetching injuries data:", error);
      }
    }

    return { injuries, caseInjuriesGraph };
  }
}
